import React from 'react';
import { ErrorContent } from '../content';
import { Card } from './module.style';

interface OwnProps {
  title?: string;
  variant?: string;
}

type Props = OwnProps & StyleProps;

export const ErrorModule = ({ title, variant, ...rest }: Props) => (
  <Card
    variant={variant}
    mobileVariant="flat"
    data-testid="error-module"
    {...rest}
  >
    <Card.Header title={title} />
    <ErrorContent variant={variant} />
  </Card>
);
